import { Badge, Button, Spinner } from "flowbite-react";
import { useState, useRef } from "react";
import { CustomModal } from "../../layouts/customModal";
import { useNavigate } from "react-router-dom";
import { MicrosoftIcn } from "../../layouts/icons";
import LoginAuthV2 from "../../services/firebaseActions/loginAuthV2";
import { AUTH_ERROR_MESSAGES } from "../../utilities/authErrors";

export const LoginModal = (props) => {
  let navigate = useNavigate();
  const modalRef = useRef(null);
  const [status, setStatus] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = () => {
    LoginAuthV2(navigate, window.location.pathname, setStatus, setIsLoading);
  };

  const handleClose = () => {
    modalRef.current();
    if (props.navigate !== "") {
      navigate(props.navigate, { replace: true });
    }
  };

  const getAuthErrorMessage = (code) => AUTH_ERROR_MESSAGES[code] || "Something went wrong. Please try again.";

  return (
    <CustomModal
      btnText={props.btnText}
      googleBtn={props.googleBtn}
      isLoading={isLoading}
      modalRef={modalRef}
      isIndex={window.location.pathname === "/"}
    >
      <div className="space-y-6 mt-2 px-6 pb-4 sm:pb-6 lg:px-8 xl:pb-8">
        {status && (
          <div className="mb-4">
            <Badge color="failure">{getAuthErrorMessage(status)}</Badge>
          </div>
        )}
        <h3 className="text-xl font-bold text-gray-900 dark:text-white">
          Sign in Required
        </h3>

        <div className="w-full google-btn">
          <Button onClick={handleLogin} disabled={isLoading ? true : false}>
            {isLoading ? (
              <span className="inline-flex items-center justify-center">
                <Spinner aria-label="spinner" />
                <span className="pl-3">Loading...</span>
              </span>
            ) : (
              <span className="inline-flex items-center justify-center">
                <MicrosoftIcn />
                Continue with Microsoft
              </span>
            )}
          </Button>
        </div>
        <div className="text-sm font-medium text-gray-500 dark:text-gray-300">
          Please sign in with your GO Markets account to continue.
        </div>
        <button
          className={`text-sm font-semibold  ${
            isLoading ? "text-gray-400" : ""
          }`}
          onClick={handleClose}
          disabled={isLoading}
        >
          Cancel
        </button>
      </div>
    </CustomModal>
  );
};
